import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import { Flex } from 'components/layout/Flex';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';

const DifferentAccount = () => {
  const [currentLookupState, setLookupState] = useRecoilState(lookupState);
  const { lookupResults, selectedResult } = currentLookupState;
  const { serialNumber, product } = selectedResult;
  const headerCard = [
    {
      title: 'Serial #:',
      value: serialNumber,
    },
    {
      title: 'Review Requested:',
      value: 'True',
    },
    {
      title: 'Associated Accounts:',
      value: selectedResult.customerName,
    },
  ];

  useEffect(() => {
    // Will always force Review Requested when it's "Different account"
    setLookupState({
      ...currentLookupState,
      reviewRequested: true,
    });
  }, [currentLookupState.selectedResult]);

  return (
    <Flex direction="column">
      {lookupResults.length === 1 ? (
        <Header
          title="Serial Number Belongs To Another Customer"
          subtitle={`Our records indicate that serial number ${selectedResult.serialNumber} is associated with other accounts. Please confirm the serial number you have provided is correct and provide the info below to submit an RMA request for this unit.`}
          cards={headerCard}
        />
      ) : null}

      <Flex spacing="space-between">
        <Flex direction="column" spacing="space-between" grow="1">
          <Product {...product} />
          <RmaFiels />
        </Flex>
        <WarrantyActions>
          <AddToRma />
        </WarrantyActions>
      </Flex>
    </Flex>
  );
};

export default DifferentAccount;
